import './Spinner.scss';

interface SprinnerProps {
  className?: string;
  reference?: any;
  id?: string;
}

export const Spinner = ({ className, reference, id }: SprinnerProps) => {
  return (
    <div
      id={id ?? ''}
      className={`spinner ${className ? className : ''}`}
      ref={reference}
    />
  );
};
